var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4173 0.333399V8.3334H18.7507V4.90007L13.4507 10.1667C13.8729 10.789 14.1951 11.4501 14.4173 12.1501C14.6395 12.8501 14.7507 13.5778 14.7507 14.3334C14.7507 16.3778 14.0395 18.1112 12.6173 19.5334C11.1951 20.9556 9.46176 21.6667 7.41732 21.6667C5.37287 21.6667 3.63954 20.9556 2.21732 19.5334C0.795095 18.1112 0.0839844 16.3778 0.0839844 14.3334C0.0839844 12.289 0.795095 10.5556 2.21732 9.1334C3.63954 7.71118 5.37287 7.00006 7.41732 7.00006C8.15065 7.00006 8.87287 7.10562 9.58398 7.31673C10.2951 7.52784 10.9507 7.85562 11.5507 8.30007L16.8507 3.00007H13.4173V0.333399H21.4173ZM7.41732 9.66673C6.12843 9.66673 5.02843 10.1223 4.11732 11.0334C3.20621 11.9445 2.75065 13.0445 2.75065 14.3334C2.75065 15.6223 3.20621 16.7223 4.11732 17.6334C5.02843 18.5445 6.12843 19.0001 7.41732 19.0001C8.70621 19.0001 9.80621 18.5445 10.7173 17.6334C11.6284 16.7223 12.084 15.6223 12.084 14.3334C12.084 13.0445 11.6284 11.9445 10.7173 11.0334C9.80621 10.1223 8.70621 9.66673 7.41732 9.66673Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.f98b6d342d33ff2a3dcfdfb612601997.svg";
export { ForwardRef as ReactComponent };